var React = require('react');

function Duration (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"points":"42.2,25.7 42.2,53.4 58.6,66.3 62.1,61.7 48,50.6 48,25.7  ","key":0}),React.createElement("path",{"d":"M47,91.3c12.9,0,24.8-5.9,32.7-16.1l-4.6-3.5c-6.8,8.8-17,13.9-28.1,13.9c-19.6,0-35.5-15.9-35.5-35.5S27.4,14.5,47,14.5   c18,0,32.9,13.5,35.2,30.9L78,41.3l-4.1,4.1L84.6,56l10.6-10.6l-4.1-4.1l-3.2,3.2C85.2,24.3,67.9,8.7,47,8.7   C24.2,8.7,5.7,27.2,5.7,50S24.2,91.3,47,91.3z","key":1})]));
}

Duration.defaultProps = {"height":"100px","width":"100px","fill":"#000000","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = Duration;

Duration.default = Duration;
